import { isUUIDV4 } from '@aline/common';
import type { UUID } from '@aline/common';
import JSZip from 'jszip';

export async function extractAlineDocumentIdFromDocx(
  docxBytes: Uint8Array | ArrayBuffer
): Promise<UUID | null> {
  const zip = await JSZip.loadAsync(docxBytes);
  const customXmlFile = zip.file('docProps/custom.xml');
  if (!customXmlFile) return null;

  const customXml = await customXmlFile.async('string');
  return extractAlineDocumentIdFromCustomXml(customXml);
}

function extractAlineDocumentIdFromCustomXml(customXml: string): UUID | null {
  const doc = new DOMParser().parseFromString(customXml, 'application/xml');
  if (doc.querySelector('parsererror')) return null;

  for (const property of Array.from(doc.documentElement.children)) {
    if (property.localName === 'property' && property.getAttribute('name') === 'alineDocumentId') {
      const valueEl = Array.from(property.children).find(child => child.localName === 'lpwstr');
      const rawValue = valueEl?.textContent?.trim();
      if (!rawValue || !isUUIDV4(rawValue)) return null;

      return rawValue;
    }
  }

  return null;
}
